import React from 'react'
import * as Bs from 'react-bootstrap'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import isBadBrowser from '_/utils/isBadBrowser'

/**
 * An messages panel widget
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class MessagePanel extends React.Component {
  static propTypes  = {
    messages: React.PropTypes.object.isRequired
  }

  getUrgentMessage() {
    return (
      <Bs.Panel bsStyle="danger" header="Immediate attention required">
        <p dangerouslySetInnerHTML={{ __html: this.props.messages.get('urgent') }}/>
      </Bs.Panel>
    )
  }

  getMaintenanceMessage() {
    return (
      <Bs.Panel bsStyle="warning" header="Maintenence alert">
        <p dangerouslySetInnerHTML={{ __html: this.props.messages.get('maintenance') }}/>
      </Bs.Panel>
    )
  }

  getBadBrowserMessage () {
    if (!isBadBrowser()) return null

    // This will cause a re-render put only for the bad browsers
    return (
      <Bs.Panel bsStyle="danger" header="You are using an unsupported browser">
        <p className="danger">
          The browser you are using is not officially supported by REDIComps.  To get the fastest, most
          feature-rich experience, we recommend you upgrade your browser or switch to another browser.
        </p>
        <p><a href="http://browsehappy.com">Find out your upgrade options here.</a></p>
      </Bs.Panel>
    )
  }

  render() {
    const { messages } = this.props
    const urlRe = /\b(https?:\/\/.*)\b/i
    const replaceText = '<a href="$1" target="_blank">link <i class="fa fa-external-link"></i></a>'

    return (
      <div>
        {this.getBadBrowserMessage()}
        {messages.get('urgent') && this.getUrgentMessage()}
        {messages.get('maintenance') && this.getMaintenanceMessage()}

        <Bs.Panel header="Announcements">
          {messages.get('announcements').map((announcement, key) => (
            <p key={key}>
              <span dangerouslySetInnerHTML={{ __html: announcement.replace(urlRe, replaceText) }}/>
            </p>
          ))}
        </Bs.Panel>
      </div>
    )
  }
}

export default MessagePanel



// WEBPACK FOOTER //
// ./modules/shared/components/messagePanel.js